import { combineReducers } from 'redux';
import _ from 'lodash';

import {
  createApiReducer,
  chainReducers,
  INITIAL_API_STATE_ITEMS,
} from 'src/api';

import {
  FETCH_LICENSES_START,
  FETCH_LICENSES_SUCCESS,
  FETCH_LICENSES_FAILURE,
  SUBMIT_LICENSES_START,
  SUBMIT_LICENSES_SUCCESS,
  SUBMIT_LICENSES_FAILURE,
  UPDATE_LICENSES_START,
  UPDATE_LICENSES_SUCCESS,
  UPDATE_LICENSES_FAILURE,
} from './actions';

const transformLicense = response => {
  return {
    fi: response.financial_institution_business_name,
    id: response.location_id,
    account: response.account_business_name,
    location: response.location_address,
    licenseNumber: response.location_license_number,
    expiration: response.location_license_date_expired,
    state: response.location_state,
    licenseLink: response.location_license_url,
    consentLink: response.location_consent_url,
    bgDate: response.background_assessment_date,
    bgResult: response.background_assessment_result,
  };
};

const fetchLicensesReducer = createApiReducer(
  [FETCH_LICENSES_START, FETCH_LICENSES_SUCCESS, FETCH_LICENSES_FAILURE],
  (payload, state) => {
    return {
      ...state.data,
      licenses: payload.map(transformLicense),
    };
  },
  error => _.get(error, 'payload.response', 'unknown error')
);

const submitLicensesReducer = createApiReducer(
  [SUBMIT_LICENSES_START, SUBMIT_LICENSES_SUCCESS, SUBMIT_LICENSES_FAILURE],
  (payload, state) => {
    const updatedLicenses = state.data.licenses.map(oldLicense => {
      const newLicense = payload.find(
        newLicense => newLicense.location_id === oldLicense.id
      );
      return newLicense ? transformLicense(newLicense) : oldLicense;
    });

    return {
      ...state.data,
      licenses: updatedLicenses,
    };
  },
  error => _.get(error, 'payload.response', 'unknown error')
);
const updateLicensesReducer = createApiReducer(
  [UPDATE_LICENSES_START, UPDATE_LICENSES_SUCCESS, UPDATE_LICENSES_FAILURE],
  (payload, state) => {
    const updatedLicenses = state.data.licenses.map(oldLicense => {
      if (oldLicense.id === payload.id) {
        // Update only the licenseLink and consentLink fields
        return {
          ...oldLicense,
          licenseLink: payload.location_license_url,
          consentLink: payload.location_consent_url,
        };
      }
      return oldLicense;
    });

    return {
      ...state.data,
      licenses: updatedLicenses,
    };
  },
  error => _.get(error, 'payload.response', 'unknown error')
);
const licenses = chainReducers(
  INITIAL_API_STATE_ITEMS,
  fetchLicensesReducer,
  submitLicensesReducer,
  updateLicensesReducer
);

export const reducer = combineReducers({
  licenses,
});
